import { render, staticRenderFns } from "./AddPreference.vue?vue&type=template&id=b2fcc718"
import script from "./AddPreference.vue?vue&type=script&lang=js"
export * from "./AddPreference.vue?vue&type=script&lang=js"
import style0 from "./AddPreference.vue?vue&type=style&index=0&id=b2fcc718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports